import * as L from "lonna"
import { Board } from "../../../common/src/domain"
import { Dispatch } from "../store/board-store"
import { BoardFocus, getSelectedItems } from "./board-focus"
import { canMove } from "./board-permissions"
import { installKeyboardShortcut } from "./keyboard-shortcuts"

export function bringToFront(board: Board, focus: BoardFocus, dispatch: Dispatch) {
    const itemIds = getSelectedItems(board)(focus)
        .filter(canMove)
        .map((i) => i.id)
    if (itemIds.length) dispatch({ action: "item.front", boardId: board.id, itemIds })
}

// ponytail: "back" is just an item.update with z below the current minimum; reuses undo and locking as-is
export function sendToBack(board: Board, focus: BoardFocus, dispatch: Dispatch) {
    const items = getSelectedItems(board)(focus).filter((i) => canMove(i) && i.type !== "container")
    if (!items.length) return
    const minZ = Math.min(0, ...Object.values(board.items).map((i) => i.z))
    dispatch({ action: "item.update", boardId: board.id, items: items.map((i) => ({ id: i.id, z: minZ - 1 })) })
}

export function itemZOrderHandler(board: L.Property<Board>, focus: L.Property<BoardFocus>, dispatch: Dispatch) {
    // ] / [ and Figma's Cmd-] / Cmd-[
    const bracket = (k: string) => (e: JSX.KeyboardEvent) => e.key === k && !e.shiftKey && !e.altKey
    installKeyboardShortcut(bracket("]"), () => bringToFront(board.get(), focus.get(), dispatch))
    installKeyboardShortcut(bracket("["), () => sendToBack(board.get(), focus.get(), dispatch))
}
